import React from 'react'
import {useItemVariant} from '@salesforce/retail-react-app/app/components/item-variant'
import {Eyebrow} from '@/components/ui/eyebrow'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {useAppOrigin} from '~/app/hooks/use-app-origin'

/**
 * In the context of a cart product item variant, this components simply renders
 * the item's name using the cart item field `productName`. We use this field
 * rather than variant `name` field as the variant detail may not yet be
 * available upon rendering.
 */
const ProductName = () => {
    const variant = useItemVariant()
    const {site} = useMultiSite()
    const appOrigin = useAppOrigin() as string
    const isSlugUrlContainsSiteId = variant?.slugUrl && variant.slugUrl.includes(site.id)
    const slugUrl = (
        variant?.slugUrl
            ? isSlugUrlContainsSiteId
                ? variant.slugUrl.split(site.id)[1]
                : '/'.concat(variant.slugUrl.split('/').splice(-2).join('/'))
            : ''
    ) as string

    const productUrl = appOrigin + slugUrl
    return (
        <a href={productUrl} className="mb-3">
            <Eyebrow
                size="small"
                className="text-emphasis hover:underline"
                style={{textTransform: 'none'}}
                data-testid="productName-Eyebrow"
                type="text"
            >
                {variant.productName || variant.name}
            </Eyebrow>
        </a>
    )
}

export default ProductName
